import { Component, OnInit, Input } from '@angular/core';

import { Constants } from '../../shared/helpers/constants';
import { StringHelpers } from '../../shared/helpers/string-helpers';

import { Company } from '../../shared/models/company';

import { Utils } from '../../shared/helpers/utils';

@Component({
    selector: 'app-open-hours',
    templateUrl: './open-hours.component.html',
    styleUrls: ['./open-hours.component.scss'],
    standalone: false
})
export class OpenHoursComponent implements OnInit {
	@Input() company: Company;

  logoPath: string;

  deparameterize = StringHelpers.deparameterize;

	deliveryStatusPtbr: string;
	nextShiftDeliveryPtbr: {
		day: string,
		short: string,
		opens: string,
		closes: string
	};

  constructor() { }

  ngOnInit(): void {
    this.logoPath = '/assets/companies-logo/' + this.company.name + ".webp";

  	if(!this.company.parsedDeliveryHours)
  		Company.setAdditionalData(this.company);

  	this.nextShiftDeliveryPtbr = {day: null, short: null, opens: null, closes: null};

  	this.deliveryStatusPtbr = Company.statusPtbr(this.company.deliveryStatus);
  	if(this.company.nextDeliveryShift) {
  		const day = Object.keys(this.company.nextDeliveryShift)[0];
  		const hours = this.company.nextDeliveryShift[day];
  		const ptbrDay = Constants.daysOfWeekPtbr[Constants.daysOfWeek.indexOf(day)];

  		this.nextShiftDeliveryPtbr = {
  			day: ptbrDay,
  			short: ptbrDay.substring(0,3),
  			opens: hours.split('-')[0],
  			closes: hours.split('-')[1]
  		};
  	}
  }
}
